import s from "./CountriesButtons.module.scss";
import { Link, useLocation } from "react-router-dom";
import { AppDispatch } from "../../redux/store";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  getIamInKazahkstan,
  getIamInOtherCountries,
  getIamInRussia,
} from "../../redux/InformationSlice";

const CountriesButtons = () => {
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <div className={s.buttons}>
      <Link
        to="/russia"
        className={location.pathname === "/russia" ? s.active_btn : s.button}
        onClick={() => dispatch(getIamInRussia())}
      >
        <div className={s.flag}>
          <img src="/images/Flag_ru.svg" alt="Ru Flag" className={s.flag_img} />
        </div>

        <div className={s.text}>
          <div className={s.flag_title}>{t("Законодательство России")}</div>
          <div className={s.flag_subtitle}>
            {t("В сфере миграции и здоровья")}
          </div>
        </div>
      </Link>
      <Link
        to="/kazakhstan"
        className={
          location.pathname === "/kazakhstan" ? s.active_btn : s.button
        }
        onClick={() => dispatch(getIamInKazahkstan())}
      >
        <div className={s.flag}>
          <img src="/images/Flag_kz.svg" alt="Ru Flag" className={s.flag_img} />
        </div>

        <div className={s.text}>
          <div className={s.flag_title}>{t("Законодательство Казахстана")}</div>
          <div className={s.flag_subtitle}>
            {t("В сфере миграции и здоровья")}
          </div>
        </div>
      </Link>
      <Link
        to="/otherCountries"
        className={
          location.pathname === "/otherCountries" ? s.active_btn : s.button
        }
        onClick={() => dispatch(getIamInOtherCountries())}
      >
        <div className={s.flag}>
          <img src="/images/Flag.svg" alt="Ru Flag" className={s.flag_img} />
        </div>

        <div className={s.text}>
          <div className={s.flag_title}>
            {t("Законодательство других стран")}
          </div>
          <div className={s.flag_subtitle}>
            {t("В сфере миграции и здоровья")}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default CountriesButtons;
